import { createFileRoute } from '@tanstack/react-router';
import { Authn } from '@frontend/auth';
import { SignInCallback } from '../../components';

export const Route = createFileRoute('/sign-in/callback')({
  component: SignInCallbackRouteComponent,
});

function SignInCallbackRouteComponent() {
  const auth: Authn = Route.useRouteContext({ select: (ctx) => ctx.auth });
  const navigate = Route.useNavigate();

  return <SignInCallback<`/sign-in/callback`> {...{ auth, navigate, signInMethod: 'okta' }} />;
}
